import {enableProdMode, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';

import {environment} from './environments/environment';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {CustomPaginatorIntl} from './app/shared/services/custom-paginator-intl.service';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {AppRoutingModule} from './app/app-routing.module';
import {bootstrapApplication, BrowserModule} from '@angular/platform-browser';
import {provideAnimations} from '@angular/platform-browser/animations';
import {CookieConsentModule} from './app/cookie-consent/cookie-consent.module';
import {LoggerModule} from 'ngx-logger';
import {RouterModule} from '@angular/router';
import {InitModule} from './app/init.module';
import {AdminModule} from './app/admin/admin.module';
import {CoreModule} from './app/core';
import {SharedModule} from './app/shared/shared.module';
import {TwpubUiModule} from './app/ui-components/twpub-ui/twpub-ui.module';
import {AppComponent} from './app/app.component';

if (environment.production) {
  enableProdMode();
}

function bootstrap() {
  // eslint-disable-next-line no-console
  bootstrapApplication(AppComponent, {
    providers: [
      provideZoneChangeDetection(),
      importProvidersFrom(AppRoutingModule, BrowserModule, CookieConsentModule, LoggerModule.forRoot({
        level: environment.logLevel
      }), RouterModule, InitModule, AdminModule, CoreModule, SharedModule, TwpubUiModule),
      {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {appearance: 'outline'}},
      {provide: MatPaginatorIntl, useClass: CustomPaginatorIntl},
      provideHttpClient(withInterceptorsFromDi()),
      provideAnimations()
    ]
  }).catch(err => console.error(err));
}

if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}
